const objects = document.querySelectorAll('.js-c-effects-tilt-on-hover')

function initTiltOnHover(object) {
  const inner = object.querySelector('.js-c-effects-tilt-on-hover__inner')
  if (!inner) return

  const maxTilt = parseFloat(object.dataset.tilt) || 10
  const perspective = parseFloat(object.dataset.perspective) || 500
  object.style.perspective = `${perspective}px`

  function handleMouseMove(e) {
    applyTilt(e, object, inner, maxTilt)
  }

  function handleMouseLeave() {
    resetTilt(inner)
  }
  // eslint-disable-next-line no-undef
  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      object.addEventListener('mousemove', handleMouseMove)
      object.addEventListener('mouseleave', handleMouseLeave)
    } else {
      object.removeEventListener('mousemove', handleMouseMove)
      object.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, {
    threshold: 0.1
  })

  observer.observe(object)
}

function applyTilt(e, object, inner, maxTilt) {
  const rect = object.getBoundingClientRect()
  const x = (e.clientX - rect.left) / rect.width - 0.5
  const y = (e.clientY - rect.top) / rect.height - 0.5
  const tiltX = y * maxTilt * -1
  const tiltY = x * maxTilt

  inner.style.transform = `rotateX(${tiltX}deg) rotateY(${tiltY}deg)`
}

function resetTilt(inner) {
  inner.style.transform = 'rotateX(0deg) rotateY(0deg)'
}

objects.forEach(object => {
  initTiltOnHover(object)
})
